import { render, staticRenderFns } from "./bo-datatable.vue?vue&type=template&id=3bfbf9ce"
import script from "./bo-datatable.vue?vue&type=script&lang=js"
export * from "./bo-datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports